/* Fit navigation to its actual rendered content, including market and language controls. */
(() => {
 const attach = () => document.querySelectorAll('x-header[data-vc-responsive]').forEach(header => {
  if(header.dataset.vcObserved) return;
  header.dataset.vcObserved='true';
  const menu=header.querySelector('.header__primary-nav > ul');
  const logo=header.querySelector('.header__logo');
  const secondary=header.querySelector('.header__secondary-nav');
  if(!menu || !logo || !secondary) return;
  const fit=()=> {
   const style=getComputedStyle(header);
   const available=(header.clientWidth-parseFloat(style.paddingLeft)-parseFloat(style.paddingRight)-logo.offsetWidth-2*parseFloat(style.columnGap))/2;
   const compact=innerWidth<1900 || menu.getBoundingClientRect().width+8>available || secondary.getBoundingClientRect().width+8>available;
   header.dataset.vcResponsive=compact?'compact':'full';
  };
  const observer=new ResizeObserver(fit);
  [header,menu,logo,secondary].forEach(element=>observer.observe(element));
  window.addEventListener('resize',fit,{passive:true});
  document.fonts.ready.then(fit);
  fit();
 });
 attach();
 document.addEventListener('shopify:section:load',attach);
})();
(() => {
 document.querySelectorAll(".vc-article__content table").forEach(table => {
  if(table.parentElement.classList.contains("vc-responsive-table")) return;
  const wrapper=document.createElement("div");
  wrapper.className="vc-responsive-table";
  const columns=[...(table.rows[0]?.cells || [])].reduce((count,cell)=>count+cell.colSpan,0);
  wrapper.style.setProperty("--vc-table-min-width",Math.max(640,columns*200)+"px");
  wrapper.tabIndex=0;
  wrapper.setAttribute("role","region");
  wrapper.setAttribute("aria-label","Comparison table. Scroll horizontally to see all columns.");
  table.before(wrapper);
  wrapper.append(table);
 });
})();
